// This file is the central place for Supabase client initialization
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { brokeredPreviewStorage } from './previewAuthStorage';

const SUPABASE_URL = "https://wptkfejcdnjjftwmwuof.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6IndwdGtmZWpjZG5qamZ0d213dW9mIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDMxNTQzODUsImV4cCI6MjA1ODczMDM4NX0.AR6V0nLQH3wIFHgin3vMQ-1DMml_2YiiOhqIXU9PvyU";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    storage: brokeredPreviewStorage(),
    persistSession: true,
    autoRefreshToken: true,
  }
});
